import React from 'react';
import { Container } from 'hocs/shared-styles';
import { Spinner } from '@hqo/react-components-library/dist/atoms/spinner';
import { defaultTheme } from '@hqo/react-components-library/dist/molecules/theme';
import { useIFrame } from 'hooks/payment-hook/use-iFrame.hook';
import { PaymentIFrameProps } from 'components/paymentIFrame/paymentIFrame.interface';
import { ModalContainer } from 'components/paymentIFrame/styles';
import { useIframeInitData } from 'hooks/payment-hook/use-iFrame-init-data.hook';
import { SwipeModal } from '@hqo/react-components-library/dist/molecules/modals/swipe-modal';

export const SwipePaymentIFrame = ({ bookingId, setBookingId }: PaymentIFrameProps) => {
  const {
    isContentLoading,
    handleIframeLoading,
    onPressBack,
    iFrameUrl,
    isCancelBookingPage,
    isCheckoutDesktop,
    isQuickCheckout,
    quickCheckout,
    isSwipeModalContent,
    handleOnClose,
  } = useIFrame(bookingId, setBookingId);
  useIframeInitData();

  const buildContent = (): JSX.Element => (
    <ModalContainer
      quickCheckout={quickCheckout}
      isCheckoutDesktop={isCheckoutDesktop}
      isQuickCheckout={isQuickCheckout}
      isSwipeModalContent={isSwipeModalContent}
    >
      {isContentLoading ? (
        <Container isLoading isIframeLoading>
          <Spinner color={defaultTheme.colors.$greyLight} size="10em" />
        </Container>
      ) : null}
      <iframe
        frameBorder="0"
        src={iFrameUrl}
        id="payment-iframe"
        title="Iframe SAML"
        height="100%"
        width={isContentLoading ? '0%' : '100%'}
        data-testid="iframe_testid"
        sandbox="allow-scripts allow-same-origin allow-presentation allow-forms allow-popups allow-popups-to-escape-sandbox allow-top-navigation"
        onLoad={handleIframeLoading}
      />
    </ModalContainer>
  );

  return (
    <SwipeModal
      reverseAnimation={false}
      content={buildContent()}
      onPressBack={onPressBack}
      onClose={handleOnClose}
      withLeftArrowButton={isCancelBookingPage}
      withLeftExitButton={!isCancelBookingPage}
    />
  );
};
